<template>
  <div class="page">
    <ActionBar :breadcrumbItems="breadcrumbItems">
      actions
    </ActionBar>

    <div class="page--content">
      UsersPage
    </div>
  </div>
</template>

<script>
import { hasRole } from 'utils/functions'
import ActionBar from 'components/Actionbar'

export default {
  name: 'UsersPage',
  components: {
    ActionBar
  },
  data () {
    return {
      breadcrumbItems: [
        { name: 'Users', title: this.$t('Views.UsersPage.title') }
      ]
    }
  },
  methods: {
    hasRole (group, role) {
      return hasRole(group, role)
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
